export const setUrl = (video) => {
    let url = video;
    if ( url.includes("embed/") ) {
        // do something
    }
    else if ( url.includes("watch?v=") ) {
        url = url.replace("watch?v=", "embed/");
    }
    else if ( url.includes("vimeo.com") && !url.includes("video") ) {
        url = url.replace("vimeo.com", "player.vimeo.com/video") + "?autoplay=1&autopause=0&controls=1";
    }
    else if ( url.includes("vimeo.com") && url.includes("video") ) {
        url = url + "?autoplay=1&autopause=0";
    }

    return url;
}

export const isExternalUrl = (url) => {
    if ( url.includes("embed/") || url.includes("watch?v=") || url.includes("vimeo.com") )
        return true;

    return false;
}